import { useRef } from "react";
import { DirectionsRenderer, GoogleMap } from "@react-google-maps/api";
import DirectionsResult = google.maps.DirectionsResult;

interface MapWithDirectionsProps {
  mapCenter: { lat: number; lng: number };
  directionsResponses: Record<string, DirectionsResult>;

  children: {
    resourceStartEndMarkers: React.ReactNode;
    resourceMarkers: React.ReactNode;
  };
}

export default function MapWithDirections({
  mapCenter,
  directionsResponses,
  children,
}: MapWithDirectionsProps) {
  const mapRef = useRef<google.maps.Map | null>(null);

  if (Object.keys(directionsResponses).length === 0) {
    // add `&& !mapRef.current` if needed
    return (
      <div className="flex h-[500px] w-full items-center justify-center">
        <p className="text-center text-sm text-gray-500">
          No directions available
        </p>
      </div>
    );
  }

  return (
    <GoogleMap
      onLoad={(map) => {
        mapRef.current = map;
      }}
      mapContainerStyle={{ width: "100%", height: "500px" }}
      clickableIcons={false}
      center={mapRef.current ? undefined : mapCenter}
      zoom={mapRef.current ? undefined : 10}
    >
      {children.resourceStartEndMarkers}
      {children.resourceMarkers}

      {Object.values(directionsResponses).map((response, index) => {
        return (
          <DirectionsRenderer
            key={index}
            directions={response}
            options={{
              polylineOptions: {
                strokeColor: getRandomCSSColor(),
                strokeOpacity: 0.5,
                strokeWeight: 5,
              },
              suppressMarkers: true, // Disables default A, B, C labels
            }}
          />
        );
      })}
    </GoogleMap>
  );
}

function getRandomCSSColor() {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}
